export const getMailboxTypeLabel = (type: string): string => {
  switch (type) {
    case 'CLASSIFIED_FMS_EMAIL':
      return 'FMS';
    case 'CLASSIFIED_SALES_EMAIL':
      return 'Sales';
    case 'CLASSIFIED_BI_EMAIL':
      return 'BI';
    default:
      return type;
  }
};

export const getMailboxTypeColor = (
  type: string,
): 'primary' | 'success' | 'warning' | 'info' | 'default' => {
  switch (type) {
    case 'CLASSIFIED_FMS_EMAIL':
      return 'primary';
    case 'CLASSIFIED_SALES_EMAIL':
      return 'success';
    case 'CLASSIFIED_BI_EMAIL':
      return 'warning';
    default:
      return 'default';
  }
};

export const formatCategory = (category: string): string =>
  category.replace(/_/g, ' ');

export const getReviewerInitials = (
  name?: string,
  email?: string,
  id?: string,
): string => {
  const source = (name || email || id || '?').trim();
  if (!source) return '?';
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return source.slice(0, 2).toUpperCase();
};

const PALETTE = [
  '#7C3AED',
  '#2563EB',
  '#0891B2',
  '#059669',
  '#CA8A04',
  '#DC2626',
  '#DB2777',
  '#9333EA',
];

export const getColorForKey = (key: string): string => {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
};

export const formatRelativeTime = (iso: string | null): string => {
  if (!iso) return 'never';
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();
  if (diffMs < 0) return 'just now';

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks}w ago`;
  return date.toLocaleDateString();
};
